import React from 'react';
import { useIntl } from 'react-intl';
import { Text } from '@box/blueprint-web';
import {
  BOX_TERMS_OF_SERVICE_URL,
  BOX_PRIVACY_NOTICE_URL,
  FORMS_LEARN_MORE_URL,
  FORM_TYPE_FORM,
  MODE,
} from '../../../constants';
import MessageRow from './message-row';
import Link from './Link';
import messages from './messages';
import css from './footer.module.scss';
import { useSplitTreatment } from '../../../common/split-treatment';
import { FEATURE_FLAGS } from '../../../constants/feature-flags';

type FooterProps = {
  enterpriseName?: string;
  formType: string;
};

const Separator = () => {
  const intl = useIntl();
  return (
    <Text as="span" className={css.separator}>
      {intl.formatMessage(messages.separator)}
    </Text>
  );
};

const Footer = (props: FooterProps) => {
  const intl = useIntl();

  const { enterpriseName = '', formType } = props;
  let footerDisplayMessage = { ...messages.fileRequestFooterMessage };

  if (formType === FORM_TYPE_FORM) {
    footerDisplayMessage = enterpriseName
      ? { ...messages.formsFooterWithEnterpriseMessage }
      : { ...messages.formsFooterMessage };
  }

  const isFormsTosEnabled = useSplitTreatment(FEATURE_FLAGS.FORMS_TOS);

  return (
    <footer className={css.footer}>
      <MessageRow>
        {
          // enterprise name is ignored if message does not use it
          intl.formatMessage(footerDisplayMessage, {
            enterprise: enterpriseName,
          })
        }
      </MessageRow>
      {/*
       // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339 */}
      <div className={css.buttonRow}>
        <Link
          className={css.linkButton}
          href={BOX_TERMS_OF_SERVICE_URL}
          rel="noopener"
          target="_blank"
        >
          {intl.formatMessage(messages.termOfServiceLink)}
        </Link>
        <Separator />
        <Link
          className={css.linkButton}
          href={BOX_PRIVACY_NOTICE_URL}
          rel="noopener"
          target="_blank"
        >
          {intl.formatMessage(messages.privacyNoticeLink)}
        </Link>
        {isFormsTosEnabled && formType === MODE.FORM && (
          <>
            <Separator />
            <Link
              className={css.linkButton}
              href={FORMS_LEARN_MORE_URL}
              rel="noopener"
              target="_blank"
            >
              {intl.formatMessage(messages.learnMoreLink)}
            </Link>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
